import { render, staticRenderFns } from "./ChatMsg.vue?vue&type=template&id=a12b5d74&scoped=true"
import script from "./ChatMsg.vue?vue&type=script&lang=js"
export * from "./ChatMsg.vue?vue&type=script&lang=js"
import style0 from "./ChatMsg.vue?vue&type=style&index=0&id=a12b5d74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12b5d74",
  null
  
)

export default component.exports